import React from 'react';
import * as Backend from '../../backend.js';
import { Link } from "react-router-dom";
import shared from "./../../share/shared.js";
import * as util from "../../other/util.js";

// The login page
export default class Login extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            outstanding_request: false,
            error_html: "",
            name: "",
            password: ""
        };
    }

    render() {
        return (
            <div style={{ "margin": "auto", "width": "600px" }}>
                <p>
                    <b>Logging in ...</b>
                </p>

                <div className="quest-story-text" style={{ "textAlign": "center" }}>
                    {this.getStory()}
                    {this.state.error_html}
                    {this.getLoginForm()}
                </div>
            </div>
        );
    }

    getStory() {
        return (
            <p>
                Welcome back commander, your empire awaits.<br />
                An authentification is required. State your name and security code:
            </p>
        );
    }

    getLoginForm() {
        return (
            <div>
                <div className="container">
                    <div>
                        <input type="text"
                            placeholder="name"
                            value={this.state.name}
                            onChange={(event) => {
                                if (event.target.value.length <= 128) {
                                    this.setState({ name: event.target.value });
                                }
                            }}
                            onKeyPress={(event) => {
                                if (event.key === "Enter") {
                                    this.onLogin();
                                }
                                return false;
                            }} />
                    </div>
                    <div>
                        <input type="password"
                            placeholder="password"
                            value={this.state.password}
                            onChange={(event) => {
                                if (event.target.value.length <= 128) {
                                    this.setState({ password: event.target.value });
                                }
                            }}
                            onKeyPress={(event) => {
                                if (event.key === "Enter") {
                                    this.onLogin();
                                }
                                return false;
                            }} />
                    </div>
                    <br />
                    <Link className="cool-button" to={{ pathname: '/', force_update: true }}>back</Link>
                    <span style={{ "margin": "20px" }} />
                    <util.DopeButton className="dope-button" label="Log in" onClick={() => { this.onLogin() }} loading={this.state.outstanding_request} />
                </div>
            </div>
        );
    }

    onLogin() {
        if (this.state.outstanding_request) {
            return;
        }

        this.setState({ outstanding_request: true });

        Backend.tryLogin(
            this.state.name,
            shared.secureHash(this.state.password),
            (res) => this.handleLoginResponse(res));
    }

    handleLoginResponse(res) {
        if (res.success) {
            this.props.onLogin();
        } else {
            if (res.details.wrong_player) {
                this.setState({ error_html: (<div style={{ color: "red" }}>Wrong player name</div>), outstanding_request: false });
            } else {
                this.setState({ error_html: (<div style={{ color: "red" }}>Wrong password</div>), outstanding_request: false });
            }
        }
    }
}
